import { P3Medium as P3MediumStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P3Medium typography style.
 */
export default function P3Medium({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P3MediumStyle, sx)} />;
}
